import React from 'react';

import { RouteConfig, Roles } from '../../routing/child-router-factory';

import {
  pathJoin,
  nonAuthenticatedRedirect,
  CreateConfigFn,
  Role,
} from '../../routing/utils';

import SelfService, {
  createRoutesMap as createSelfServiceMap,
} from './routes/self-service/SelfService';

import { createRoutesMap as createContainersRouteMap } from './routes/containers/route-config';

import Containers from './routes/containers/Containers';

import { createRoutesMap as createCollectionsRouteMap } from './routes/collections/route-config';

import Collections from './routes/collections/Collections';

import ViewNotifications from './routes/notifications/Notifications';

import { createRoutesMap as createNotificationsMap } from './routes/notifications/route-config';

import Products from './routes/products/Products';

type Keys =
  | `self-service`
  | `containers`
  | `collections`
  | `finance`
  | `messages`
  | `notifications`
  | `products`;

export const createRouteMap = (prefix: string) => ({
  selfService: {
    _: pathJoin(prefix)(`self-service`).value,
    ...createSelfServiceMap(pathJoin(prefix)(`self-service`).value.slice(1)),
  },
  containers: {
    _: pathJoin(prefix)(`containers`).value,
    ...createContainersRouteMap(pathJoin(prefix)(`containers`).value.slice(1)),
  },
  collections: {
    _: pathJoin(prefix)(`collections`).value,
    ...createCollectionsRouteMap(
      pathJoin(prefix)(`collections`).value.slice(1)
    ),
  },
  notifications: {
    _: pathJoin(prefix)('notifications').value,
    ...createNotificationsMap(pathJoin(prefix)(`notifications`).value.slice(1)),
  },
  products: {
    _: pathJoin(prefix)(`products`).value,
  },
});

export type RouteMap = ReturnType<typeof createRouteMap>;

const authenticatedUser: Roles = {
  and: ['authenticated'],
};

export const createConfig: CreateConfigFn<Keys> = (map) => {
  const arr: (Omit<RouteConfig<Keys>, 'fallback' | `roles`> & {
    roles?: Roles;
  })[] = [
    {
      key: 'self-service',
      path: map.app.selfService._,
      children: <SelfService />,
    },
    {
      key: 'containers',
      path: map.app.containers._,
      children: <Containers />,
    },
    {
      key: 'collections',
      path: map.app.collections._,
      children: <Collections />,
    },
    {
      key: 'notifications',
      path: map.app.notifications._,
      children: <ViewNotifications />,
    },
    {
      key: 'products',
      path: map.app.products._,
      children: <Products />,
    },
  ];

  return [
    ...arr.map((c) => ({
      roles: authenticatedUser,
      fallback: (roles: Role[]) => nonAuthenticatedRedirect(map)(roles),
      ...c,
    })),
  ];
};
